export default __webpack_public_path__ + "static/media/inputs.6acd11e0.svg";